/* @flow */
import $ from 'jquery';
import moment from 'moment';
import 'moment/locale/pt-br';
import { type IntervaloData } from './types';

const getRanges = () => ({
    Hoje: [moment(), moment()],
    Ontem: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Mês atual': [moment().startOf('month'), moment().endOf('month')],
    'Mês anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Últimos 3 meses': [moment().subtract(2, 'month').startOf('month'), moment().endOf('month')],
    'Últimos 6 meses': [moment().subtract(5, 'month').startOf('month'), moment().endOf('month')],
    'Últimos 12 meses': [moment().subtract(12, 'month').startOf('month'), moment().endOf('month')],
});

type Opcoes = {
    id: string,
    dataInicial: string,
    dataFinal: string,
    callback: IntervaloData => void,
};

const getLabel = ({ dataFinal, dataInicial }: IntervaloData): string => {
    if (dataInicial === dataFinal) {
        return moment(dataInicial, 'YYYY-MM-DD').format('L');
    }

    return [dataInicial, dataFinal]
        .map(data => moment(data, 'YYYY-MM-DD').format('L'))
        .join(' - ');
};

const dateRangePickerComOpcoes = ({
    dataFinal,
    dataInicial,
    id,
    callback,
}: Opcoes) => {
    const picker = $(id);
    if (!picker.length) {
        return;
    }

    const startDate = moment(dataInicial);
    const endDate = moment(dataFinal);

    picker
        .find('.m-subheader__daterange-date')
        .html(getLabel({ dataInicial, dataFinal }));

    // $FlowFixMe
    picker.daterangepicker({
        startDate,
        endDate,
        autoUpdateInput: false,
        opens: 'left',
        showDropdowns: true,
        format: 'DD/MM/YYYY',
        ranges: getRanges(),
        dateLimit: { days: 365 },
        locale: {
            applyLabel: 'Aplicar',
            cancelLabel: 'Cancelar',
            fromLabel: 'De',
            toLabel: 'até',
            customRangeLabel: 'Selecione um período',
            daysOfWeek: ['Do', 'Se', 'Te', 'Qua', 'Qui', 'Se', 'Sa'],
            monthNames: [
                'Janeiro',
                'Fevereiro',
                'Março',
                'Abril',
                'Maio',
                'Junho',
                'Julho',
                'Agosto',
                'Setembro',
                'Outubro',
                'Novembro',
                'Dezembro',
            ],
            firstDay: 1,
        },
    }, (inicio, fim) => {
        const intervaloData = { dataInicial: inicio.format('Y-MM-D'), dataFinal: fim.format('Y-MM-D') };
        picker.find('.m-subheader__daterange-date').html(getLabel(intervaloData));
        callback(intervaloData);
    });
};

export default dateRangePickerComOpcoes;
